export const VETTING_AUTO_REJECT_RULE = Object.freeze({
  Q5_HESITATION: 'q5_hesitation',
  SHORT_ANSWERS: 'short_answers',
  SPAM_BOT: 'spam_bot',
  DUPLICATE_APPLICATION: 'duplicate_application',
});

export const VETTING_AUTO_REJECT_RULE_LABELS = Object.freeze({
  [VETTING_AUTO_REJECT_RULE.Q5_HESITATION]:
    'Auto-rejected due to hesitation or weak commitment on question 5',
  [VETTING_AUTO_REJECT_RULE.SHORT_ANSWERS]: 'Auto-rejected because too many answers were too short',
  [VETTING_AUTO_REJECT_RULE.SPAM_BOT]: 'Auto-rejected due to spam or bot-like behavior',
  [VETTING_AUTO_REJECT_RULE.DUPLICATE_APPLICATION]:
    'Auto-rejected because a duplicate application was detected',
});

export const getVettingAutoRejectRuleLabel = (rule) => {
  const key = String(rule || '')
    .trim()
    .toLowerCase();
  if (!key) return null;
  return (
    VETTING_AUTO_REJECT_RULE_LABELS[key] ??
    key
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ')
  );
};
